import { FC } from "react"
import { useTranslation } from "react-i18next"
import styles from "./SearchInput.module.scss"
import { ISearchInputProps } from "./types"

export const SearchInput: FC<ISearchInputProps> = ({ value, onChange }) => {
  const { t } = useTranslation("inventory")
  return (
    <label className={styles.SearchInput}>
      <input
        type="search"
        className={styles.SearchInput_field}
        value={value}
        placeholder={t("search.placeholder")}
        onChange={(event) => onChange(event.target.value)}
      />
      <span className={styles.SearchInput_icon} aria-hidden="true">
        ⌕
      </span>
    </label>
  )
}
